import {Injectable, Pipe, PipeTransform} from '@angular/core';

@Pipe({standalone: true, name: 'replaceSlashWithUnderscore'})
@Injectable({
  providedIn: 'root',
})
export class ReplaceSlashWithUnderscorePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    // Check if the value is a string, otherwise return an empty string or a default value
    if (typeof value !== 'string') {
      return '';
    }
    return value.replace(/\//g, '_');
  }
}
